<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0" style="margin-top: auto;">
            <div class="row">
              <div class="col-lg-4">
                <card
                  class="border-0 d-flex card-sipp"
                  hover
                  shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"
                >
                  <object
                    data="/img/svg/9-SIPP.svg"
                    type="image/svg+xml"
                    class="text-white card-pajak"
                  ></object>
                  <h6
                    class="text-white text-uppercase title-inside-card"
                    style="margin-top: 7px"
                  >SIPP</h6>
                </card>
              </div>
              <div class="col-lg-8">
                <h1 class="display-3 text-white">
                  Informasi Pelaporan Pajak Daerah
                  <span>Kabupaten Ketapang</span>
                </h1>
                <br />
                <br />
                <br />
                <br />
                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="info"
                    textColor="white"
                    icon="fa fa-arrow-left"
                    @click="goback()"
                  >Kembali</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <section class="section section-lg pt-lg-0 mt--200">
      <card
        class="border-0"
        style="margin-left:10%;margin-right:10%;margin-top:20px;"
        shadow
        body-classes="py-5"
      >
        <div class="d-block">
          <h4 class="page-title">Dashboard</h4>
          <hr />
          <b-row>
            <b-col lg="12" sm="12" xs="12">
              <div
                :title="false"
                style="padding: 10px 5px 0px 5px; background-image: linear-gradient(135deg, #fdc359, #fbe1b0 60%, #5bffff);"
              >
                <marquee>
                  <div class="d-flex justify-content-between align-items-center">
                    <h5 style="color:black">
                      <b>
                        Penerimaan Pendapatan Daerah TA {{data.year}} s/d hari ini sebesar :
                        <b>{{data.tableMasterFoot.persen.toFixed(2)}}%</b> atau
                        <b>{{formatToMoney(data.tableMasterFoot.bulanTotal)}}</b>.
                      </b>
                      <b>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</b>
                      <b>Terdiri dari &nbsp;</b>
                      <template v-for="(n,index) in data.tableMaster">
                        <b :key="index" v-if="n.no != ''">
                          <b>{{n.jenis_pajak}}</b>
                          sebesar &nbsp;
                          <b>{{(n.persen.toFixed(2))}}%</b> atau
                          <b>{{formatToMoney(n.bulanTotal)}}</b>.
                          <b>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</b>
                        </b>
                      </template>
                      <b>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</b>
                    </h5>
                  </div>
                </marquee>
              </div>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6" sm="12" xs="12">
              <div class="pb-xlg h-100">
                <card
                  class="border-0 d-flex"
                  hover
                  shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"
                >
                  <icon name="fa fa-money" type="primary" rounded class="mb-4"></icon>
                  <h6 class="text-primary text-uppercase">{{title_to_this}}</h6>
                  <h2>{{reception_yesterday}}</h2>
                  <i class="la la-arrow-right text-success rotate-315" />
                </card>
              </div>
            </b-col>
            <b-col lg="6" sm="12" xs="12">
              <div class="pb-xlg h-100">
                <card
                  class="border-0 d-flex"
                  hover
                  shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"
                >
                  <icon name="fa fa-money" type="info" rounded class="mb-4"></icon>
                  <h6 class="text-info text-uppercase">Total Penerimaan Hari ini</h6>
                  <h2>{{reception_today}}</h2>
                  <i class="la la-arrow-right text-success rotate-315" />
                </card>
              </div>
            </b-col>
          </b-row>
          <hr />

          <b-row>
            <b-col lg="6" sm="12" xs="12">
              <!-- <card
                class="border-0 d-flex"
                hover
                shadow
                body-classes="text-center align-items-center d-flex justify-content-center"
              > -->
                <highcharts :options="chartOption2"></highcharts>
              <!-- </card> -->
            </b-col>
            <b-col lg="6" sm="12" xs="12">
              <!-- <card
                class="border-0 d-flex"
                hover
                shadow
                body-classes="text-center align-items-center d-flex justify-content-center"
              > -->
                <highcharts :options="chartOption3"></highcharts>
              <!-- </card> -->
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col xs="12">
              <highcharts :options="chartOption1"></highcharts>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="12">
                <div class="table-responsive">
                  <table class="table table-bordered w-100 d-block d-md-table">
                    <thead>
                      <tr>
                        <th rowspan="2">
                          <b>NO</b>
                        </th>
                        <th rowspan="2">
                          <b>NO REKENING</b>
                        </th>
                        <th rowspan="2">
                          <b>JENIS PAJAK</b>
                        </th>
                        <th rowspan="2">
                          <b>TARGET ANGGARAN</b>
                        </th>
                        <th colspan="3">
                          <b>JUMLAH REALISASI BULAN INI</b>
                        </th>
                        <th rowspan="2">
                          <b>PRESENTASE(%)</b>
                        </th>
                        <th rowspan="2">
                          <b>LEBIH (KURANG)</b>
                        </th>
                      </tr>
                      <tr>
                        <th>
                          <b>BULAN INI</b>
                        </th>
                        <th>
                          <b>S/D BULAN SEBELUMNYA</b>
                        </th>
                        <th>
                          <b>S/D BULAN INI</b>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in data.tableMaster" :key="data.id">
                        <template v-if="data.no == ''">
                          <td>{{data.no}}</td>
                          <td>{{data.nomor_rekening}}</td>
                          <td>{{data.jenis_pajak}}</td>
                          <td class="money">{{formatToMoney(data.targetAnggaran)}}</td>
                          <td class="money">{{formatToMoney(data.bulanSekarang)}}</td>
                          <td class="money">{{formatToMoney(data.bulanLalu)}}</td>
                          <td class="money">{{formatToMoney(data.bulanTotal)}}</td>
                          <td class="persen">{{(data.persen.toFixed(2))}}</td>
                          <td class="money">{{formatToMoney(data.bulanTotal-data.targetAnggaran)}}</td>
                        </template>
                        <template v-else>
                          <td>
                            <b>{{data.no}}</b>
                          </td>
                          <td>
                            <b>{{data.nomor_rekening}}</b>
                          </td>
                          <td>
                            <b>{{data.jenis_pajak}}</b>
                          </td>
                          <td class="money">
                            <b>{{formatToMoney(data.targetAnggaran)}}</b>
                          </td>
                          <td class="money">
                            <b>{{formatToMoney(data.bulanSekarang)}}</b>
                          </td>
                          <td class="money">
                            <b>{{formatToMoney(data.bulanLalu)}}</b>
                          </td>
                          <td class="money">
                            <b>{{formatToMoney(data.bulanTotal)}}</b>
                          </td>
                          <td class="persen">
                            <b>{{(data.persen.toFixed(2))}}</b>
                          </td>
                          <td class="money">
                            <b>{{formatToMoney(data.bulanTotal-data.targetAnggaran)}}</b>
                          </td>
                        </template>
                      </tr>
                    </tbody>
                    <tfoot>
                      <td colspan="3">
                        <b>JUMLAH SELURUHNYA</b>
                      </td>
                      <td class="money">
                        <b>{{formatToMoney(data.tableMasterFoot.targetAnggaran)}}</b>
                      </td>
                      <td class="money">
                        <b>{{formatToMoney(data.tableMasterFoot.bulanSekarang)}}</b>
                      </td>
                      <td class="money">
                        <b>{{formatToMoney(data.tableMasterFoot.bulanLalu)}}</b>
                      </td>
                      <td class="money">
                        <b>{{formatToMoney(data.tableMasterFoot.bulanTotal)}}</b>
                      </td>
                      <td class="persen">
                        <b>{{(data.tableMasterFoot.persen.toFixed(2))}}</b>
                      </td>
                      <td class="money">
                        <b>{{formatToMoney(data.tableMasterFoot.bulanTotal-data.tableMasterFoot.targetAnggaran)}}</b>
                      </td>
                    </tfoot>
                  </table>
                </div>
            </b-col>
          </b-row>
        </div>
      </card>
    </section>
  </div>
</template>
<script>
import { BCol, BRow } from "bootstrap-vue";
import formatMoney from "accounting-js/lib/formatMoney.js";
import { mapGetters } from "vuex";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import highchartsData from "highcharts/modules/data";
import highchartsdrilldown from "highcharts/modules/drilldown";

highchartsData(Highcharts);
highchartsdrilldown(Highcharts);
export default {
  name: "Sipp",
  components: {
    BCol,
    BRow,
    highcharts: Chart,
  },
  data() {
    return {
      timer: "",
      selectedYears: new Date().getFullYear(),
      loading: true,
      selectedType: 1,
    };
  },
  computed: {
    ...mapGetters("dashboard", {
      data: "data",
    }),
    piutang_pbb() {
      return this.formatToMoney(this.data.piutangPbb);
    },
    piutang_bphtb() {
      return this.formatToMoney(this.data.piutangBphtb);
    },
    piutang_plain() {
      return this.formatToMoney(this.data.piutangPlain);
    },
    reception_today() {
      return this.formatToMoney(this.data.recept_toDay);
    },
    reception_yesterday() {
      return this.formatToMoney(this.data.recept_yesterday);
    },
    realisasiPresen() {
      return (
        (this.data.totalSemuaPenerimaan / this.data.target) *
        100
      ).toFixed(2);
    },
    penerimaan() {
      return this.formatToMoney(this.data.totalSemuaPenerimaan);
    },
    title_to_this() {
      return (
        "Total Penerimaan sampai dengan hari ini pada bulan " +
        this.data.name_month +
        " " +
        this.data.year
      );
    },
    chartOption2() {
      return {
        chart: {
          type: "pie",
        },
        title: {
          text:
            "Kontribusi penerimaan PAD terhadap pendapatan APBD tahun Anggaran " +
            this.data.year,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          headerFormat: "",
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.percentage:.2f}%</b> of total<br/>',
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.percentage:.2f}%",
            },
          },
        },
        series: [
          {
            name: "Penerimaan",
            colorByPoint: true,
            data: this.data.series2,
          },
        ],
        drilldown: {
          series: this.data.drilldown,
        },
      };
    },
    chartOption3() {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        title: {
          text: "Komposisi penerimaan PAD Tahun Anggaran " + this.data.year,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.2f}%</b>",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.2f} %",
            },
          },
        },
        series: [
          {
            name: "Penerimaan",
            colorByPoint: true,
            data: this.data.series3,
          },
        ],
      };
    },
    chartOption1() {
      return {
        chart: {
          type: "column",
        },
        title: {
          text: "Tahun Anggaran " + this.data.year,
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
        yAxis: {
          title: {
            text: "Rupiah (Rp.)",
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: true,
          },
        },
        series: this.data.series,
      };
    },
  },
  created() {
    if (this.id) {
      this.selectedType = this.id;
    }
    this.handlerRefresh();
    this.timer = setInterval(this.handlerRefresh, 300000);
  },
  methods: {
    formatToMoney(value) {
      if (value) {
        return formatMoney(parseFloat(value), {
          symbol: "Rp. ",
          precision: 2,
          thousand: ".",
          decimal: ",",
        });
      } else {
        return null;
      }
    },
    presenTarget(target, realisasi) {
      if (realisasi == 0 || target == 0) {
        return 0;
      }
      return ((realisasi / target) * 100).toFixed(2);
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    async handlerRefresh() {
      this.loading = true;
      await this.$store.dispatch("dashboard/setData", {
        year: this.selectedYears,
      });
      this.loading = false;
    },
    goback() {
      this.$router.go(-1);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew + .shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card-sipp {
  height: 100%;
}

.chart-wrapper {
  position: relative;
  padding-bottom: 40%;
}

.chart-inner {
  position: absolute;
  width: 100%;
  height: 100%;
}

table {
  tbody tr {
    td {
      min-width: 100px;
    }
  }
}

.table-bordered thead th {
  text-align: center;
}

.table-bordered tbody td {
  font-size: 0.7rem;
}

.table-bordered tfoot td {
  font-size: 0.7rem;
}

.money {
  text-align: right;
}

.persen {
  text-align: center;
}

.table-bordered thead th,
.table-bordered thead td {
  border-width: 2px !important;
  /* border-color: #8e8585; */
  border-top-width: 2px !important;
}

.text-small > h2 {
  font-size: 1.3rem;
}
</style>